export default __webpack_public_path__ + "static/media/ushan.2c2c8b86.jpg";